export default {
  index:'1면',
  majorsys:'주요 시스템',
  platform:'전문 플랫폼',
  miniapp:'미니 프로그램',
};
